import { Component,  inject,  OnInit } from "@angular/core";
import { WebhookCommonComponent } from "../common.components";
import { NzModalService } from "ng-zorro-antd/modal";
import { WorkFlowAction } from "../../webhook-interfaces/configuration";

@Component({
    selector: 'webhook-form-input',
    templateUrl: './webhook-form-input.component.html',
    styleUrl: './webhook-form-input.component.scss',
    standalone: false
})

export class WebhookFormInputComponent extends WebhookCommonComponent implements OnInit {
   
    

}